var findYourSize = (event) => {
  event.preventDefault();
  const summary = document.querySelector(".size_guide summary");
  const testTab = document.querySelector(".test-tab-size");

  if (summary && !summary.parentElement.hasAttribute("open")) {
    summary.click();
    setTimeout(() => {
      if (testTab) {
        testTab.scrollIntoView({ behavior: "smooth" });
      }
    }, 300);
  } else if (testTab) {
    testTab.scrollIntoView({ behavior: "smooth" });
  }
};

var openTab = (event, tabName) => {
  event.preventDefault();

  const tabContent = document.querySelectorAll(".tab-content-size");
  tabContent.forEach((content) => content.classList.remove("active"));

  const tabLinks = document.querySelectorAll(".tab-links-size a");
  tabLinks.forEach((link) => link.classList.remove("active"));

  document.querySelectorAll("#" + tabName).forEach((tabItem) => tabItem.classList.add("active"));
  
  event.currentTarget.classList.add("active");
};

document.addEventListener("DOMContentLoaded", () => {
  const sizeGuide = document.querySelector(".size_guide");
  if (sizeGuide) {
    if (!document.querySelector(".find-size")) {
      const newLink = document.createElement("a");
      newLink.href = "#";
      newLink.textContent = "Find your size";
      newLink.classList.add("find-size");
      newLink.onclick = findYourSize;

      const optionInfo6 = document.querySelector(
        "fieldset.variant-picker__option.option--size.v-stack.gap-2.no-js\\:hidden .variant-picker__option-info"
      );
      if (optionInfo6) {
        optionInfo6.appendChild(newLink);
      }
    }
  }
  
 
});


